export default "__VITE_ASSET__D5pWn1kS__"